import { render } from "./crispchat.vue?vue&type=template&id=0213a18c"
import script from "./crispchat.vue?vue&type=script&lang=js"
export * from "./crispchat.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__